module.exports = __webpack_public_path__ + "media/components/breakheader/background/background--2-c266ad3ccad3492406e6376d32df84cb.jpg";